import { render, staticRenderFns } from "./form4Accreditation.vue?vue&type=template&id=126c938c&scoped=true"
import script from "./form4Accreditation.vue?vue&type=script&lang=js"
export * from "./form4Accreditation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c938c",
  null
  
)

export default component.exports